const API_BASE_URL = 'https://employee-tracker-ap2x.onrender.com';
export default API_BASE_URL;
